import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface RatingsDashboardStars {
  name: string;
  value: number;
}

@Injectable({
  providedIn: 'root'
})
export class RatingsMapperService {

  constructor(
    private translate: TranslateService
  ) { }

  public convertRatingsByQuantityData(ratingsByQuantity): RatingsDashboardStars[] {
    return [
      {
        name: '1 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STAR'),
        value: ratingsByQuantity.oneStarCount
      },
      {
        name: '2 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STARS'),
        value: ratingsByQuantity.twoStarsCount
      },
      {
        name: '3 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STARS'),
        value: ratingsByQuantity.threeStarsCount
      },
      {
        name: '4 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STARS'),
        value: ratingsByQuantity.fourStarsCount
      },
      {
        name: '5 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STARS'),
        value: ratingsByQuantity.fiveStarsCount
      },
    ];
  }
}
